module.exports = __webpack_public_path__ + "static/media/passatempo.9d608334.webp";